var map = {
	"./editorBaseApi": 2806,
	"./editorBaseApi.js": 2806,
	"./editorSimpleWorker": 6722,
	"./editorSimpleWorker.js": 6722,
	"./editorWorker": 3412,
	"./editorWorker.js": 3412,
	"./editorWorkerHost": 1978,
	"./editorWorkerHost.js": 1978,
	"./findSectionHeaders": 2743,
	"./findSectionHeaders.js": 2743,
	"./getIconClasses": 5286,
	"./getIconClasses.js": 5286,
	"./languageFeatureDebounce": 3603,
	"./languageFeatureDebounce.js": 3603,
	"./languageFeatures": 8058,
	"./languageFeatures.js": 8058,
	"./languageFeaturesService": 2529,
	"./languageFeaturesService.js": 2529,
	"./languageService": 8207,
	"./languageService.js": 8207,
	"./languagesAssociations": 1440,
	"./languagesAssociations.js": 1440,
	"./languagesRegistry": 3871,
	"./languagesRegistry.js": 3871,
	"./markerDecorations": 6490,
	"./markerDecorations.js": 6490,
	"./markerDecorationsService": 8329,
	"./markerDecorationsService.js": 8329,
	"./model": 2794,
	"./model.js": 2794,
	"./modelService": 7305,
	"./modelService.js": 7305,
	"./resolverService": 9174,
	"./resolverService.js": 9174,
	"./semanticTokensDto": 1356,
	"./semanticTokensDto.js": 1356,
	"./semanticTokensProviderStyling": 580,
	"./semanticTokensProviderStyling.js": 580,
	"./semanticTokensStyling": 5967,
	"./semanticTokensStyling.js": 5967,
	"./semanticTokensStylingService": 3560,
	"./semanticTokensStylingService.js": 3560,
	"./textModelSync/textModelSync.impl": 6453,
	"./textModelSync/textModelSync.impl.js": 6453,
	"./textModelSync/textModelSync.protocol": 1056,
	"./textModelSync/textModelSync.protocol.js": 1056,
	"./textResourceConfiguration": 3212,
	"./textResourceConfiguration.js": 3212,
	"./treeSitterParserService": 6556,
	"./treeSitterParserService.js": 6556,
	"./treeViewsDnd": 6079,
	"./treeViewsDnd.js": 6079,
	"./treeViewsDndService": 1272,
	"./treeViewsDndService.js": 1272,
	"./unicodeTextModelHighlighter": 4403,
	"./unicodeTextModelHighlighter.js": 4403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5834;